type QueryParams = {
  boutiqueReferenceKeys?: (string | null)[] | null;
  countryCode: string;
  eyewearAvailable?: boolean;
  latLng?: string | null;
  mode?: string | null;
  numberOfStores?: string | null;
  webVisible?: boolean;
};

export const makeQueryString = (params: QueryParams): string => {
  const query = new URLSearchParams();

  query.append('countryCode', params.countryCode);

  if (params.latLng) query.append('latLng', params.latLng);
  if (params.mode) query.append('mode', params.mode);
  if (params.numberOfStores)
    query.append('numberOfStores', params.numberOfStores);
  if (params.boutiqueReferenceKeys && params.boutiqueReferenceKeys.length > 0) {
    query.append(
      'boutiqueReferenceKeys',
      params.boutiqueReferenceKeys.join(','),
    );
  }
  if (params.webVisible !== undefined) {
    query.append('web_visible', params.webVisible.toString());
  }
  if (params.eyewearAvailable === true) {
    query.append('eyewear_available', 'true');
  }

  return `${query.toString()}`;
};
